// extracted by mini-css-extract-plugin
export default {"modal-content":"SignUpModal_modal-content__6R+Vf","login-section":"SignUpModal_login-section__YERLG","menu-item":"SignUpModal_menu-item__Kzixy","icon":"SignUpModal_icon__shB7-"};